"use client";

import { useEffect, useRef } from 'react';

/**
 * Determine the value of a specified variable at last render. Often
 * useful in cases where previously you'd access prevProps or prevState
 * in componentDidUpdate lifecycle methods.
 *
 * @example
 *
 * ```js
 * const [showing, setShowing] = useState(false);
 * const wasShowing = usePrevious(showing);
 * ```
 *
 * @param {any} state the value to track
 */

export function usePrevious<T = any>(value: T) {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
